import { render, staticRenderFns } from "./AddAttribuites.vue?vue&type=template&id=73707407"
import script from "./AddAttribuites.vue?vue&type=script&lang=js"
export * from "./AddAttribuites.vue?vue&type=script&lang=js"
import style0 from "./AddAttribuites.vue?vue&type=style&index=0&id=73707407&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports